var $export = require('./_export');

$export($export.S + $export.F, 'Object', {classof: require('./_classof')});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.classof.js
// module id = 862
// module chunks = 14